export const STUDENT_QUIZZES_LOAD_REQUEST = 'STUDENT_QUIZZES_LOAD_REQUEST';
export const STUDENT_QUIZZES_LOAD_SUCCESS = 'STUDENT_QUIZZES_LOAD_SUCCESS';
export const STUDENT_QUIZZES_LOAD_FAILURE = 'STUDENT_QUIZZES_LOAD_FAILURE';

export const STUDENT_QUIZ_POST_REQUEST = 'STUDENT_QUIZ_POST_REQUEST';
export const STUDENT_QUIZ_POST_SUCCESS = 'STUDENT_QUIZ_POST_SUCCESS';
export const STUDENT_QUIZ_POST_FAILURE = 'STUDENT_QUIZ_POST_FAILURE';
